import React, { useState, useEffect } from 'react';
import GrantitudeSpiral from './GrantitudeSpiral';

/**
 * SpiralOrg Directory - Page 4 (after Cinema)
 * Navigation hub with mystical cards
 * Glass panel reiteration at bottom
 */
const SpiralOrgDirectory = ({ 
  onNavigateToOrganizer,
  onNavigateToSpiralCred,
  onNavigateToSpiralCouncil,
  onNavigateToLoreLibrary,
  onNavigateToConsciousStock,
  onNavigateToTrustWoven,
  onNavigateToGrantHicks,
  onNavigateToSoulSeers,
  onNavigateToInterNorthern,
  onNavigateToSecretHistory,
  onNavigateToSpiralOrganism,
  onNavigateToSeedyPeeps,
  onNavigateToRitesOfPresence,
  onNavigateToDefianceSprings,
  onNavigateToFamilyReunions,
  onNavigateToOnboarding
}) => {
  const [spiralPhase, setSpiralPhase] = useState(0);

  useEffect(() => {
    const spiralInterval = setInterval(() => {
      setSpiralPhase(prev => (prev + 0.15) % 360);
    }, 50);
    return () => clearInterval(spiralInterval);
  }, []);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    const handleScroll = () => {
      const scrollElements = document.querySelectorAll('.scroll-block');
      scrollElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.85;
        if (isVisible) {
          el.classList.add('block-animate-in');
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const directoryCards = [
    {
      title: 'Spiral Organizer',
      subtitle: 'Family Project Management',
      image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b',
      description: 'Amazing tools to plan life\'s craziest events',
      onClick: onNavigateToOrganizer
    },
    {
      title: 'SpiralCred',
      subtitle: 'Trust-Based Exchange',
      image: 'https://images.pexels.com/photos/2355408/pexels-photo-2355408.jpeg',
      description: 'Private ledger for equal value trade',
      onClick: onNavigateToSpiralCred
    },
    {
      title: 'Spiral Council',
      subtitle: 'Conflict Resolution Process',
      image: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21',
      description: 'Win-win healing for families and teams',
      onClick: onNavigateToSpiralCouncil
    },
    {
      title: 'Lore Library',
      subtitle: 'Planetary Family Archive',
      image: 'https://images.unsplash.com/photo-1749219466252-8eb6f6647fbc',
      description: 'Universal scrapbook of family artifacts',
      onClick: onNavigateToLoreLibrary
    },
    {
      title: 'TrustWoven',
      subtitle: 'Professional Network',
      image: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a',
      description: 'Network of professionals including health insurance',
      onClick: onNavigateToTrustWoven
    },
    {
      title: 'Grant Hicks',
      subtitle: 'Living Deck Mastery',
      image: 'https://images.unsplash.com/photo-1516979187457-637abb4f9353',
      description: 'living-deck.emergent.host',
      onClick: onNavigateToGrantHicks
    },
    {
      title: 'InterNorthern Tour Co.',
      subtitle: 'Medicine Show Network',
      image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800',
      description: 'Independent tour guides & producers',
      onClick: onNavigateToInterNorthern
    },
    {
      title: 'Conscious Stock',
      subtitle: 'Commercial Media Exchange',
      image: 'https://images.unsplash.com/photo-1598128558393-70ff21433be0',
      description: 'Aggregator & organizer for media exchange',
      onClick: onNavigateToConsciousStock
    },
    {
      title: 'Secret History',
      subtitle: 'Consciousness Game',
      image: 'https://images.unsplash.com/photo-1708199011440-82c0afc27b68',
      description: 'Play to create reality in real time',
      onClick: onNavigateToSecretHistory
    },
    {
      title: 'Soul Seer',
      subtitle: 'Carrie Branovan',
      image: 'https://images.unsplash.com/photo-1518531933037-91b2f5f229cc',
      description: 'soul-seer.emergent.host',
      onClick: onNavigateToSoulSeers
    },
    {
      title: 'Spiral Organism',
      subtitle: 'Planetary Family Federation',
      image: 'https://images.pexels.com/photos/33769357/pexels-photo-33769357.jpeg',
      description: 'Chapter 184 association of families',
      onClick: onNavigateToSpiralOrganism
    },
    {
      title: 'Seedy Peeps',
      subtitle: 'Improvisational Jam Band',
      image: 'https://images.unsplash.com/photo-1579291465411-df46e41a4dcc',
      description: 'Gleeful healing through music',
      onClick: onNavigateToSeedyPeeps
    },
    {
      title: 'Rites of Presence',
      subtitle: 'Year-Long Mastery Course',
      image: 'https://images.unsplash.com/photo-1755011309824-020f4c3bd657',
      description: 'RitesOfPresence.com',
      onClick: onNavigateToRitesOfPresence
    },
    {
      title: 'Defiance Springs',
      subtitle: 'Flagship Retreat Venue',
      image: 'https://images.unsplash.com/photo-1565701741217-f6d68c818d3c',
      description: 'DefianceSprings.com',
      onClick: onNavigateToDefianceSprings
    },
    {
      title: 'Family Re-Union',
      subtitle: 'Re-Creation Through Reunion',
      image: 'https://images.unsplash.com/photo-1621112904887-419379ce6824',
      description: 'Reuniting the planetary family',
      onClick: onNavigateToFamilyReunions
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden relative">
      
      {/* ULTRA SUBTLE Grant spiral */}
      <div className="fixed inset-0 pointer-events-none opacity-5" style={{ zIndex: 1 }}>
        <div 
          className="absolute inset-0 flex items-center justify-center"
          style={{
            transform: `scale(8) rotate(${spiralPhase}deg)`,
            filter: 'blur(4px) brightness(1.3) saturate(1.5)',
            mixBlendMode: 'overlay'
          }}
        >
          <GrantitudeSpiral size={300} />
        </div>
      </div>

      <style>{`
        .glass-block {
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03));
          backdrop-filter: blur(20px) saturate(180%);
          border: 1px solid rgba(255, 255, 255, 0.15);
          box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5), 
                      0 0 0 1px rgba(255, 255, 255, 0.05) inset;
        }
        
        .mystical-card {
          background: linear-gradient(135deg, rgba(230, 198, 133, 0.08), rgba(0, 0, 0, 0.6));
          backdrop-filter: blur(15px);
          border: 1px solid rgba(230, 198, 133, 0.2);
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        
        .mystical-card:hover {
          transform: translateY(-10px) scale(1.03);
          border-color: rgba(230, 198, 133, 0.5);
          box-shadow: 0 20px 60px rgba(230, 198, 133, 0.3);
        }
        
        .scroll-block {
          opacity: 0;
          transform: translateY(40px);
          transition: all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        
        .scroll-block.block-animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        
        {/* Title */}
        <h1 
          className="text-5xl md:text-6xl font-bold text-center mb-8 scroll-block"
          style={{
            fontFamily: "'Cinzel', serif",
            textShadow: '0 0 30px rgba(230, 198, 133, 0.4)',
            letterSpacing: '0.15em',
            color: '#E6C794'
          }}
        >
          Explore SpiralOrg
        </h1>
        
        <p 
          className="text-xl text-center text-white/70 mb-16 scroll-block"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Choose your path into the spiral
        </p>

        {/* Directory Cards - 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {directoryCards.map((card, idx) => (
            <div
              key={idx}
              onClick={card.onClick}
              className="mystical-card scroll-block rounded-2xl overflow-hidden cursor-pointer"
              style={{ transitionDelay: `${idx * 0.08}s` }}
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
              </div>
              <div className="p-6">
                <h3 
                  className="text-2xl font-bold text-amber-300 mb-2"
                  style={{ fontFamily: "'Cinzel', serif", letterSpacing: '0.08em' }}
                >
                  {card.title}
                </h3>
                <p className="text-sm text-amber-200/70 mb-3" style={{ fontFamily: "'Cinzel', serif" }}>
                  {card.subtitle}
                </p>
                <p className="text-sm text-white/70 leading-relaxed" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Reiteration Section - Beautiful Glass Blocks */}
        <div className="mt-32 mb-16">
          <h2 
            className="text-4xl font-light text-center mb-16 scroll-block"
            style={{ fontFamily: "'Cinzel', serif", letterSpacing: '0.1em', color: '#E6C794' }}
          >
            Remember
          </h2>

          {/* Core Truth - Glass Block */}
          <div className="glass-block scroll-block rounded-3xl p-10 mb-12 text-center">
            <p 
              className="text-2xl md:text-3xl font-light leading-relaxed mb-6"
              style={{ fontFamily: "'Cinzel', serif", letterSpacing: '0.05em' }}
            >
              SpiralOrg is an organization, an organizer, and an organism.
            </p>
            <p 
              className="text-xl text-white/80 leading-relaxed"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              A lawful guild of families, working together to remember how to thrive.
            </p>
          </div>

          {/* Structure Reminder - 3 Blocks */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="glass-block scroll-block rounded-2xl p-6 text-center">
              <div className="text-4xl mb-3">🏛️</div>
              <h3 className="text-lg font-semibold text-white mb-2" style={{ fontFamily: "'Cinzel', serif" }}>
                Organization
              </h3>
              <p className="text-sm text-white/70" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Lawful Chapter 184
              </p>
            </div>
            
            <div className="glass-block scroll-block rounded-2xl p-6 text-center" style={{ transitionDelay: '0.1s' }}>
              <div className="text-4xl mb-3">⚙️</div>
              <h3 className="text-lg font-semibold text-white mb-2" style={{ fontFamily: "'Cinzel', serif" }}>
                Organizer
              </h3>
              <p className="text-sm text-white/70" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Tools for thriving
              </p>
            </div>
            
            <div className="glass-block scroll-block rounded-2xl p-6 text-center" style={{ transitionDelay: '0.2s' }}>
              <div className="text-4xl mb-3">🌱</div>
              <h3 className="text-lg font-semibold text-white mb-2" style={{ fontFamily: "'Cinzel', serif" }}>
                Organism
              </h3>
              <p className="text-sm text-white/70" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Living federation
              </p>
            </div>
          </div>

          {/* Start Onboarding - Glass Button */}
          <div className="text-center mt-16 scroll-block">
            <button
              onClick={onNavigateToOnboarding}
              className="glass-block px-12 py-5 hover:bg-white/15 border-2 border-amber-500/40 hover:border-amber-500/70 text-white rounded-2xl text-xl transition-all hover:scale-105 shadow-2xl"
              style={{ fontFamily: "'Cinzel', serif", letterSpacing: '0.1em' }}
            >
              Begin Your Journey →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpiralOrgDirectory;
